import { isWebsiteBuilderTabset, IWebsiteBuilderTabset } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderTabset";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderGeneralTraversalNode } from "../../actionHelpers/generalTraversal";
import {
  IWebsiteBuilderEditorHistoryActionBase,
  IWebsiteBuilderHistorySnapshot,
  WebsiteBuilderEditorActionType,
} from "../../websiteBuilderEditorAction";

export interface ISwapTabActionPayload {
  tabsetId: string;
  prevIndex: number;
  nextIndex: number;
}

export interface ISwapTabAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.SWAP_TAB;
  payload: ISwapTabActionPayload;
}

export function getSwapTabInverseAction(action: ISwapTabAction): ISwapTabAction {
  const { tabsetId, prevIndex, nextIndex } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.SWAP_TAB,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      tabsetId,
      prevIndex: nextIndex,
      nextIndex: prevIndex,
    },
  };
}

type TSwapTabTraversalNode = IWebsiteBuilderTabset | IWebsiteBuilderGeneralTraversalNode;

function swapTabTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  tabsetId: string,
  prevIndex: number,
  nextIndex: number,
): IWebsiteBuilderHistorySnapshot {
  function traverse(node: TSwapTabTraversalNode): TSwapTabTraversalNode {
    if (isWebsiteBuilderTabset(node)) {
      if (
        node.id !== tabsetId ||
        prevIndex === nextIndex ||
        prevIndex < 0 ||
        nextIndex < 0 ||
        prevIndex >= node.children.length ||
        nextIndex >= node.children.length
      ) {
        return node;
      }

      const children = [...node.children];

      const temp = children[prevIndex];

      children[prevIndex] = children[nextIndex];
      children[nextIndex] = temp;

      return {
        ...node,
        children,
      };
    } else if (node.children) {
      return {
        ...node,
        children: node.children.map(traverse),
      };
    } else {
      return node;
    }
  }

  return {
    header: traverse(header) as IWebsiteBuilderHeader,
    root: traverse(root) as IWebsiteBuilderRoot,
    footer: traverse(footer) as IWebsiteBuilderFooter,
  };
}

export function applySwapTabChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: ISwapTabAction,
): IWebsiteBuilderHistorySnapshot {
  const { tabsetId, prevIndex, nextIndex } = action.payload;

  return swapTabTraversal(header, root, footer, tabsetId, prevIndex, nextIndex);
}
